import { CSSResultArray, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { PCCarousel } from '../pc-carousel/pc-carousel';

import carouseltStyles from '../pc-carousel/pc-carousel.css.lit';
import componentStyles from './pc-testimonial-carousel.css.lit';
import testimonialStyles from '../pc-testimonial/pc-testimonial.css.lit';
import testimonialLightDomStyles from '../pc-testimonial/pc-testimonial.lightDom.css.lit';
import imageStyles from '../pc-image/pc-image.lightDom.css.lit';
import headingStyles from '../pc-heading/pc-heading.lightDom.css.lit';
import detailStyles from '../pc-detail/pc-detail.css.lit';
import captionStyles from '../pc-caption/pc-caption.css.lit';
import wysiwygStyles from '../pc-wysiwyg/pc-wysiwyg.lightDom.css.lit';

import '../pc-container/pc-container';

/**
 * Testimonial Carousel component
 * @element pc-testimonial-carousel
 * @slot - This element has a default slot
 */
@customElement('pc-testimonial-carousel')
export class PCTestimonialCarousel extends PCCarousel {
  static styles: CSSResultArray = [
    carouseltStyles,
    componentStyles,
    imageStyles,
    headingStyles,
    detailStyles,
    captionStyles,
    wysiwygStyles,
    testimonialStyles,
    testimonialLightDomStyles,
  ];

  render(): TemplateResult {
    return html`
      <div class="carousel carousel--testimonial">
        ${this.carouselTemplate()}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-testimonial-carousel': PCTestimonialCarousel;
  }
}
